
let hot = function (a) {
	return a;
};

if (module.hot) {
	 hot = require('react-hot-loader/root').hot;
}

exports.hot = hot;
